import React, { useEffect, useState } from "react";

import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { startSubscriptionAsync } from "helpers/business/getBusiness";
import { logOut } from "helpers/userCheck/logOut";

import SubscriptionModal from "components/organisms/SubscriptionModal";
import SwalAlertComp from "components/SwalAlert";

import {
    clearSidebarItem,
    setSidebarItem,
    setSubscriptionModal,
} from "../../../redux/slices/app/app.slice";
import { getBusinessAsync } from "../../../redux/slices/dashboardDatas/dashboardDatas.asyncActions";
import { getExcistTrackersRedux } from "../../../redux/slices/trackers/trackers.asyncActions";
import { handleLocationChange } from "./SidebarManager.helpers";
import SidebarUI from "./SidebarUI";

const SidebarManager = ({
    isSidebarOpen,
    sidebarOpenedItem,
    trackers,
    trackersStatus,
    language,
    bussiness,
    activeTrackers,
    subscriptionModal,
}) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const dispatchSetSidebarItem = (item) => dispatch(setSidebarItem(item));
    const dispatchClearSidebarItem = () => dispatch(clearSidebarItem());
    const [activeItem, setActiveItem] = useState(null);

    const [isAccountDropdownOpen, setIsAccountDropdownOpen] = useState(false);
    const [leadService, setLeadService] = useState(false);
    const [landingPageService, setLandingPageService] = useState(false);
    const [signalService, setSignalService] = useState(false);

    const [trackersCheckStatus, setTrackersCheckStatus] = useState(false);
    const [shouldShowExitButton, setShouldShowExitButton] = useState(false);
    const [bussinessName, setBussinessName] = useState("");

    const [isLoadingLeadSubscription, setIsLoadingLeadSubscription] =
        useState(false);

    const [
        isLoadingLandingPageSubscription,
        setIsLoadingLandingPageSubscription,
    ] = useState(false);

    const [isLeadModalOpen, setIsLeadModalOpen] = useState(false);
    const [isLandingPageModalOpen, setIsLandingPageModalOpen] = useState(false);

    useEffect(() => {
        dispatch(getExcistTrackersRedux() as any);
        setTrackersCheckStatus(true);
    }, []);

    useEffect(() => {
        if (trackersCheckStatus && activeTrackers) {
            setShouldShowExitButton(true);
        } else {
            setShouldShowExitButton(false);
        }
    }, [trackersCheckStatus, activeTrackers]);

    useEffect(() => {
        let businessId =
            bussiness &&
            bussiness.length > 0 &&
            bussiness.find((element) => element.selected === true);

        setSignalService(
            businessId?.services &&
                businessId.services.length > 0 &&
                businessId.services.some((item) => item.service === "signal"),
        );
        setLeadService(
            businessId?.services &&
                businessId.services.length > 0 &&
                businessId.services.some((item) => item.service === "lead"),
        );
        setLandingPageService(
            businessId?.services &&
                businessId.services.length > 0 &&
                businessId.services.some((item) => item.service === "landpg"),
        );
    }, [bussiness]);

    useEffect(() => {
        if (bussiness) {
            setBussinessName(
                [...bussiness].find((x) => x?.selected === true)?.name,
            );
        }
    }, [bussiness]);

    const onLogout = async () => {
        let result = await logOut();
        if (result.status) {
            localStorage.clear();
            window.location.href =
                process.env.REACT_APP_CONSOLE_URL +
                "/dash/logout_continue?url=" +
                process.env.REACT_APP_SINGLE_PAGE;
        }
    };

    useEffect(() => {
        handleLocationChange({
            dispatchClearSidebarItem,
            dispatchSetSidebarItem,
            location,
            setActiveItem,
        });
    }, [location]);

    const startLeadSubscription = async () => {
        let data = {
            package_code: "LEAD-B",
        };
        setIsLoadingLeadSubscription(true);
        let response = await startSubscriptionAsync(data);
        setIsLoadingLeadSubscription(false);
        if (response.status) {
            dispatch(getBusinessAsync() as any);
            !subscriptionModal && navigate("/lead-connections");
            setIsLeadModalOpen(false);
            subscriptionModal && dispatch(setSubscriptionModal(null));
            subscriptionModal && window.location.reload();
        } else {
            SwalAlertComp({
                title: language?.delete_swal_modal?.failed ?? "Failed",
                message: response.message && response.message,
                icon: "error",
            });
        }
    };
    const startLandingPageSubscription = async () => {
        let data = {
            package_code: "LANDPG-B",
        };
        setIsLoadingLandingPageSubscription(true);
        let response = await startSubscriptionAsync(data);
        setIsLoadingLandingPageSubscription(false);

        if (response.status) {
            dispatch(getBusinessAsync() as any);
            !subscriptionModal && navigate("/landing-pages");
            setIsLandingPageModalOpen(false);
            subscriptionModal && dispatch(setSubscriptionModal(null));
            subscriptionModal && window.location.reload();
        } else {
            SwalAlertComp({
                title: language?.delete_swal_modal?.failed ?? "Failed",
                message: response.message && response.message,
                icon: "error",
            });
        }
    };

    useEffect(() => {
        subscriptionModal === "landpg" && setIsLandingPageModalOpen(true);
        subscriptionModal === "lead" && setIsLeadModalOpen(true);
    }, [subscriptionModal]);

    return (
        !location.pathname.includes("landing-pages/edit") &&
        !location.pathname.includes("create-landing-page") &&
        !location.pathname.includes("landing-pages/clone") &&
        location.pathname !== "/wizard" && (
            <>
                {isLeadModalOpen && (
                    <SubscriptionModal
                        modalTitle={"Lead Service Activation"}
                        contentTitle={"Ready to Active Your Subscription ?"}
                        onTrigger={startLeadSubscription}
                        isLoadingTrigger={isLoadingLeadSubscription}
                        setIsOpen={setIsLeadModalOpen}
                        isOpen={isLeadModalOpen}
                        imageSrc={"/assets/images/subscription.jpg"}
                        content={
                            <>
                                By starting your subscription, you’ll gain
                                instant access to premium lead management
                                features and tools designed to boost your
                                business performance.
                            </>
                        }
                    />
                )}
                {isLandingPageModalOpen && (
                    <SubscriptionModal
                        modalTitle={"Landing Page Service Activation"}
                        contentTitle={"Ready to Active Your Subscription ?"}
                        onTrigger={startLandingPageSubscription}
                        setIsOpen={setIsLandingPageModalOpen}
                        isOpen={isLandingPageModalOpen}
                        imageSrc={"/assets/images/landing-page-subcription.jpg"}
                        isLoadingTrigger={isLoadingLandingPageSubscription}
                        content={
                            <>
                                By starting your subscription, you’ll gain
                                instant access to premium landing page creation
                                and optimization tools.
                                <br /> Effortlessly design, publish, and manage
                                high-converting landing pages to drive more
                                traffic, capture leads, and boost your business
                                performance.
                            </>
                        }
                    />
                )}
                <SidebarUI
                    isSidebarOpen={isSidebarOpen}
                    bussinessName={bussinessName}
                    isAccountDropdownOpen={isAccountDropdownOpen}
                    language={language}
                    onLogout={onLogout}
                    setIsAccountDropdownOpen={setIsAccountDropdownOpen}
                    shouldShowExitButton={shouldShowExitButton}
                    trackersStatus={trackersStatus}
                    trackers={trackers}
                    dispatchSetSidebarItem={dispatchSetSidebarItem}
                    landingPageService={landingPageService}
                    leadService={leadService}
                    setIsLandingPageModalOpen={setIsLandingPageModalOpen}
                    setIsLeadModalOpen={setIsLeadModalOpen}
                    sidebarOpenedItem={sidebarOpenedItem}
                    signalService={signalService}
                    setActiveItem={setActiveItem}
                    activeItem={activeItem}
                />
            </>
        )
    );
};

export default SidebarManager;
